export const notaryServices = [
  // 1️⃣ Property Transfer upon Death
  {
    key: "inheritance",
    title: "Transfer of Property or Rights upon Death",
    requirements: [
      "Death certificate of the deceased",
      "Birth certificates of all heirs",
      "Copies of national ID cards of all heirs",
      "Title deed",
      "Copy of the inheritance deed (estate settlement)",
      "Copies of national ID cards of witnesses",
    ],
  },

  // 2️⃣ Lease Agreement
  {
    key: "rent",
    title: "Lease Agreement",
    requirements: [
      "Birth certificate of the lessor (property owner)",
      "Birth certificate of the tenant",
      "Copies of national ID cards of each party",
      "Title deed",
      "Property insurance certificate",
    ],
  },

  // 3️⃣ Guardianship Account
  {
    key: "guardianship",
    title: "Guardianship Account",
    requirements: [
      "Birth certificate of the testator",
      "Birth certificate of the beneficiary",
      "Property title deed (if applicable)",
      "Copies of national ID cards of witnesses",
    ],
  },

  // 4️⃣ Marriage Contract
  {
    key: "marriage",
    title: "Marriage Contract",
    requirements: [
      "Birth certificate of the groom",
      "Birth certificate of the bride",
      "Birth certificate of the guardian (wali)",
      "Copy of national ID card of the groom",
      "Copy of national ID card of the bride",
      "Copy of national ID card of the guardian",
      "Copies of national ID cards of witnesses",
      "Medical certificate of the groom",
      "Medical certificate of the bride",
    ],
  },

  // 5️⃣ Report of Delivery of Second Executory Copy
  {
    key: "executive_copy",
    title: "Report of Delivery of the Second Executory Copy",
    requirements: [
      "Executory copy filled with the executory formula",
      "Copy of the national ID card of the requester",
    ],
  },

  // 6️⃣ Mortgage Release
  {
    key: "mortgage_release",
    title: "Release of Official Mortgage, Privilege, or Possessory Lien",
    requirements: [
      "Copy of the official or possessory mortgage deed",
      "Birth certificates of all parties",
      "Copies of national ID cards of all parties",
      "Property insurance certificate (if applicable)",
      "Proof of debt settlement (full or partial)",
    ],
  },

  // 7️⃣ Property Publication
  {
    key: "property_publication",
    title: "Publication of Notarial Real Estate Contracts",
    requirements: [
      "Copy of the unpublished title deed",
      "Birth certificate of the concerned party",
      "Copy of national ID card",
      "Property insurance certificate",
    ],
  },

  // 8️⃣ Amicable Partition
  {
    key: "partition",
    title: "Amicable Partition",
    requirements: [
      "Property title deed",
      "Birth certificates of all parties",
      "Copies of national ID cards of all parties",
      "Property insurance certificate",
      "Copy of the real estate appraisal report",
    ],
  },

  // 9️⃣ Report of Opening Financial Safes
  {
    key: "safe_opening",
    title: "Report of Opening Financial Safes",
    requirements: [
      "Copy of the inheritance deed",
      "Birth certificates of those concerned with opening the safe",
      "Copies of national ID cards of those concerned",
    ],
  },

  // 🔟 Power of Attorney
  {
    key: "power_of_attorney",
    title: "Power of Attorney, Revocation, and Substitution of Agent",
    requirements: [
      "Copy of national ID card of the principal",
      "Copy of national ID card of the agent",
      "Birth certificates of the principal and agent",
      "Bank or postal account number (if needed)",
      "Title deed (if for sale or lease)",
      "Copy of the power of attorney (in case of revocation)",
    ],
  },

  // 11️⃣ Promise to Contract
  {
    key: "promise_contract",
    title: "Promise to Contract",
    requirements: [
      "Birth certificates of all parties",
      "Copies of national ID cards of all parties",
      "Property title deed",
      "Property insurance certificate",
    ],
  },

  // 12️⃣ Debt Discharge
  {
    key: "debt_clearance",
    title: "Debt Discharge",
    requirements: [
      "Copy of the debt acknowledgment deed",
      "Copies of national ID cards of the creditor and debtor",
      "Birth certificates of the creditor and debtor",
    ],
  },

  // 13️⃣ Company Contract
  {
    key: "company_contract",
    title: "Company Contract",
    requirements: [
      "Company name certificate",
      "Birth certificate of the founder",
      "Copies of national ID cards of all partners",

      "Articles of association or founding contract",
      "Commercial register",
      "NIF - Tax identification number",
      "NIS - Statistical identification number",

      "Articles of association of the company",
      "Commercial register",
      "NIF + NIS",
    ],
  },

  // 14️⃣ Other Services
  {
    key: "other_services",
    title: "Other Services",
    requirements: [
      "Depending on the legal situation",
      "Additional documents may be required at the notary's discretion",
    ],
  },
];

export const huissierServices = [
  // 1️⃣ Notification and Summons Reports
  {
    key: "notification_reports",
    title: "Notification and Summons Reports",
    requirements: [
      "Notice of warning report",
      "Notice of warning by court order",
      "Summons notification report",
      "Petition notification report",
      "Notification of a deed or document",
      "Notification of the executory instrument",
      "Summons notification by posting in legal locations",
      "Notification via publication in a national newspaper",
    ],
  },

  // 2️⃣ Inspection and Status Reports
  {
    key: "inspection_reports",
    title: "Inspection and Status Verification Reports",
    requirements: [
      "Inspection and status verification report",
      "Status verification report by court order",
      "Interrogation report by court order",
      "Declaration receipt report",
      "Execution dispute report",
    ],
  },

  // 3️⃣ Forced Execution Reports
  {
    key: "execution_reports",
    title: "Forced Execution Reports",
    requirements: [
      "Report of in-kind or equivalent execution",
      "Report of refusal to execute",
      "Attempt of in-kind or equivalent execution",
      "Eviction report (residence / premises / land)",
      "Eviction attempt",
      "Key handover report",
      "Installation report",
    ],
  },

  // 4️⃣ General Seizure Orders
  {
    key: "general_seizure_orders",
    title: "Seizure Orders and Procedures",
    requirements: [
      "Petition for seizure / inspection / warning / door opening",
      "Assessment of custodian fee / custodian replacement",
      "Entry into premises",
      "Drafting the payment demand report",
      "Notification of payment demand",
    ],
  },

  // 5️⃣ Payment Offer
  {
    key: "payment_offer",
    title: "Payment Offer",
    requirements: [
      "Report of notification of material payment offer",
      "Report of deposit of payment offer after refusal",
      "Return of offered funds to the offeror by court order",
    ],
  },

  // 6️⃣ Seizure of Debtor's Assets Held by Third Party
  {
    key: "third_party_seizure",
    title: "Seizure of Debtor's Assets Held by Third Party",
    requirements: [
      "Drafting the order petition",
      "Notification of the order to the garnishee",
      "Seizure report",
      "Notification of the seizure report to the debtor",
      "Summons of the seizing creditor",
      "Summons of the seized debtor",
      "Summons of the garnishee",
      "Drafting the allocation petition",
      "Notification of the allocation order",
      "Execution report",
    ],
  },

  // 7️⃣ Seizure of Movables
  {
    key: "movable_seizure",
    title: "Seizure of Movable Property",
    requirements: [
      "Petition for movable seizure order",
      "Notification of the seizure order",
      "Seizure and inventory",
      "Notification of the seizure and inventory report",
      "Re-inventory",
      "Sale announcement of seized items",
      "Posting of announcements (court / municipality / tax office / post office)",
      "Publication in national newspaper (if exceeding 200,000 DZD)",
      "Sale report",
      "Price collection report",
      "Delivery and removal of sold movables",
      "Filing the sale report with the clerk's office",
    ],
  },

  // 8️⃣ Real Estate Seizure
  {
    key: "real_estate_seizure",
    title: "Seizure of Real Estate",
    requirements: [
      "Petition for real estate seizure order",
      "Notification of the order to the debtor and third parties",
      "Seizure and inventory",
      "Notification to the tax authority",
      "Filing the seizure at the real estate registry",
      "Payment demand notice",
      "Request for property record",
      "Appointment of an expert to determine the opening price",
      "Notification to the expert",
      "List of sale conditions",
      "Filing the list with the clerk's office",
      "Notification to all parties (debtor / creditor / heirs / partners)",
      "Setting the sale date",
      "Publishing the sale announcement in a national newspaper",
      "Posting announcements in public locations",
      "Public auction session",
      "Auction award",
      "Registration of the judgment at the real estate registry",
    ],
  },

  // 9️⃣ Precautionary Seizure
  {
    key: "precautionary_seizure",
    title: "Precautionary Seizure",
    requirements: [
      "Petition for precautionary seizure order",
      "Notification of the order",
      "Seizure report (movable)",
      "Registration of seizure at the real estate registry (real estate)",
      "Registration of the precautionary seizure order",
    ],
  },
];

export const servicesDataMap = {
  notary: notaryServices,
  judicial_expert: huissierServices, // عدّل هادي إذا huissier مربوطة بخدمة أخرى عندك
};

export function getServicesFor(serviceName) {
  return servicesDataMap[serviceName] || [];
}

export function getServiceByKey(serviceName, key) {
  const list = getServicesFor(serviceName);
  return list.find((s) => s.key === key);
}
